/** Convert a 0-based column index to an A1-style column letter. */
export function columnLetter(col: number): string {
  let result = "";
  let n = col;
  while (n >= 0) {
    result = String.fromCharCode(65 + (n % 26)) + result;
    n = Math.floor(n / 26) - 1;
  }
  return result;
}

/** Convert (0-based row, 0-based col) to A1-style address, e.g. (2, 1) -> "B3". */
export function addressFromRC(row: number, col: number): string {
  return `${columnLetter(col)}${row + 1}`;
}
